import React from 'react';
import { LoaderContainer, LoaderWrapper } from './Loader.style';

// Loader from https://loading.io/css/

const Loader = () => (
  <LoaderWrapper>
    <LoaderContainer>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </LoaderContainer>
  </LoaderWrapper>
);

export default Loader;
